import React from "react";
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from "react-icons/fi";
import { Link } from "react-router-dom";

const CopyrightTwo = () => {
  return (
    <div className="copyright-area copyright-style-one variation-two">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-4 col-md-7 col-sm-12 col-12">
            <div className="copyright-left">
              <ul className="ft-menu link-hover">
                <li>
                <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about-us">About</Link>
                </li>
                <li>
                <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-5 mt_sm--20">
            <div className="copyright-center text-center">
              <ul className="social-icon social-default color-lessdark justify-content-center">
                {/* <li>
                  <Link to="facebook.com">
                    <FiFacebook />
                  </Link>
                </li>
                <li>
                  <Link to="twitter.com">
                    <FiTwitter />
                  </Link>
                </li>
                <li>
                  <Link to="instagram.com">
                    <FiInstagram />
                  </Link>
                </li> */}
                <li>
                  <Link to="https://linkedin.com/company/moftahsolutions/" target="_blank" rel="noopener noreferrer">
                    <FiLinkedin />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 col-sm-12 col-12 mt_md--20 mt_sm--20">
            <div className="copyright-right text-center text-lg-right">
              <p className="copyright-text">
                © Moftah Solutions, LLC {new Date().getFullYear()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CopyrightTwo;
